import type { UpdateCategoryGroup } from '@mynt/backoffice-api-spec/spendcontrols'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { updateCategoryGroup } from 'SpendControl/endpoints'

export type UpdateCategoryGroupParams = { id: string } & UpdateCategoryGroup

export const useUpdateCategoryGroup = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCategoryGroupParams) => updateCategoryGroup(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
